export const COMMENT = 1
export const CONTRACT_STATUS = 2